import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { ContactUsFormValidation } from '../../constants/validationSchemas.ts';
import { useTranslation } from 'react-i18next';
import { sendEmail, useCustomNavigation } from '../../utility/Utility.ts';
import Select from 'react-select';
import countryList  from '../../assets/data/json/countries.json';

const GetInTouchComponent = () => {
    const {t} = useTranslation();
    const customNavigate = useCustomNavigation();

    const initialValues = {
        firstName: "",
        lastName: "",
        email: "",
        country: {
            value: "",
            label: ""
        },
        phoneNumber: "",
        message: "",
        // isPrivacyPolicyChecked: false,
    };

    const handleSubmitForm = async (values: any, { resetForm }) => {
        sendEmail(`
            Name: ${values.firstName} ${values.lastName}
            Email: ${values.email}
            Country: ${values.country.label}
            Phone Number: ${values.country.value} ${values.phoneNumber}
            Message: ${values.message}
        `);

        resetForm(initialValues);
    };

    return (
        <div className="section">
        <div className="grid lg:grid-cols-2 gap-8 px-5 lg:px-0">
            <div className="flex flex-col gap-12">
                <div className="grid gap-4">
                    <p className={`text-3xl font-semibold text-black-1A1 lg:text-5xl`}>{t('CONTACT_US.WE_ARE_ALWAYS_READY')}</p>
                    <p className={`text-base font-normal text-gray-666 lg:text-xl`}>{t('CONTACT_US.OUR_FRIENDLY_TEAM')}</p>
                </div>
                <div className="grid grid-cols-1 gap-12 sm:grid-cols-2">
                    <div className="grid gap-3 lg:gap-8">
                        <p className="text-xl font-semibold text-black-1A1">{t('COMMON.EMAIL')}</p>
                        <p className="text-lg font-medium text-gray-666 cursor-pointer">{t('FOOTER.EMAIL_INNOVII')}</p>
                    </div>
                    <div className="grid gap-3 lg:gap-8">
                        <p className="text-xl font-semibold text-black-1A1">{t('COMMON.SOCIAL_NETWORK')}</p>
                        <div className="flex flex-wrap gap-3">
                            {
                                SocialMediaLinkList.map((item, index: number) => (
                                    <div key={index} className="flex gap-2 items-center cursor-pointer hover:underline" onClick={() => customNavigate(false, item.link)} >  {/* Redirection link */}
                                        <img loading="lazy" src={item?.img} alt={t(item?.title)} />
                                        <p className="text-lg font-medium text-gray-666 cursor-pointer">{t(item.title)}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid bg-gray-F7F rounded-xl py-5 px-4 gap-8 lg:py-8 lg:px-16 lg:rounded-[1.125rem] lg:gap-12">
                <div className="grid gap-2">
                    <p className="text-xl font-semibold text-black-1A1 lg:text-[2rem]">{t('CONTACT_US.GET_IN_TOUCH')}</p>
                    <p className="text-sm font-normal text-gray-666 lg:text-xl">{t('CONTACT_US.KINDLY_HELP_FILL_INFORMATION')}</p>
                </div>
                <div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={ContactUsFormValidation()}
                        onSubmit={handleSubmitForm}
                        >
                        {({ values, setFieldValue, errors, validateForm, }) => {
                            return (
                                <Form className="form">
                                    <div className="grid gap-6 sm:grid-cols-2 sm:gap-5 lg:gap-8">
                                        <div className="field-box">
                                            <label htmlFor="firstName" className="required">{t('FORM.FIRST_NAME')}</label>
                                            <Field
                                                className=""
                                                placeholder={t('FORM.ENTER_HERE')}
                                                type="text"
                                                name="firstName"
                                                id="firstName"
                                                value={values.firstName}
                                                errors={errors.firstName}
                                            />
                                            <ErrorMessage
                                                name="firstName"
                                                component="p"
                                                className="error-msg"
                                            />
                                        </div>
                                        <div className="field-box">
                                            <label htmlFor="lastName" className="required">{t('FORM.LAST_NAME')}</label>
                                            <Field
                                                className=""
                                                placeholder={t('FORM.ENTER_HERE')}
                                                type="text"
                                                name="lastName"
                                                id="lastName"
                                                value={values.lastName}
                                                errors={errors.lastName}
                                            />
                                            <ErrorMessage
                                                name="lastName"
                                                component="p"
                                                className="error-msg"
                                            />
                                        </div>
                                    </div>
                                    <div className="field-box">
                                        <label htmlFor="email" className="required">{t('COMMON.EMAIL')}</label>
                                        <Field
                                            className=""
                                            placeholder={t('FORM.EMAIL_EXAMPLE')}
                                            type="email"
                                            name="email"
                                            id="email"
                                            value={values.email}
                                            errors={errors.email}
                                        />
                                        <ErrorMessage
                                            name="email"
                                            component="p"
                                            className="error-msg"
                                        />
                                    </div>
                                    <div className="grid gap-6 sm:grid-cols-2 sm:gap-5 lg:gap-8">
                                        <div className="field-box">
                                            <label htmlFor="country" className="required">{t('FORM.COUNTRY')}</label>
                                            <Select
                                                id="country"
                                                name="country"
                                                options={countryList.map(item => ({ value: item.code, label: item.name }))}
                                                value={values.country} // This binds the selected value
                                                onChange={(selectedOption) => setFieldValue('country', selectedOption)} // Update Formik state
                                                placeholder={t('FORM.SELECT')}
                                                isSearchable
                                            />
                                            <ErrorMessage
                                                name="country.value"
                                                component="p"
                                                className="error-msg"
                                            />
                                        </div>
                                        <div className="field-box">
                                            <label htmlFor="phoneNumber" className="">{t('FORM.PHONE_NUMBER')}</label>
                                            <div className="input-container flex">
                                                {/* <Field
                                                    as="select"
                                                    className=""
                                                    name="msisdn.countryCode"
                                                    value={values.msisdn.countryCode}
                                                    >
                                                    {
                                                        countryCodeList.map((item, index: number) => (
                                                            <option key={index} value={item.code}>{item.name}</option>
                                                        ))
                                                    }
                                                </Field> */}
                                                <Field
                                                    className="w-full"
                                                    placeholder={t('FORM.ENTER_HERE')}
                                                    type="number"
                                                    name="phoneNumber"
                                                    id="phoneNumber"
                                                    value={values.phoneNumber}
                                                    errors={errors.phoneNumber}
                                                />
                                            </div>
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="p"
                                                className="error-msg"
                                            />
                                        </div>
                                    </div>
                                    <div className="field-box">
                                        <label htmlFor="message" className="required">{t('FORM.MESSAGE')}</label>
                                        <Field
                                            as="textarea"
                                            className=""
                                            placeholder={t('FORM.LEAVE_US_MESSAGE')}
                                            type="text"
                                            name="message"
                                            id="message"
                                            value={values.message}
                                            rows="4" // Adjust the size of the textarea
                                        />
                                        <ErrorMessage
                                            name="message"
                                            component="p"
                                            className="error-msg"
                                        />
                                    </div>
                                    {/* <div className="flex gap-3">
                                        <Field
                                            className="w-4 h-4 lg:w-5 lg:h-5"
                                            placeholder={t('FORM.LEAVE_US_MESSAGE')}
                                            type="checkbox"
                                            name="isPrivacyPolicyChecked"
                                            id="isPrivacyPolicyChecked"
                                            value={values.isPrivacyPolicyChecked}
                                            checked={values.isPrivacyPolicyChecked}
                                        />
                                        <p className={`text-xs font-normal text-gray-666 lg:text-sm`}>{t('FORM.ACCEPT_PRIVACY_POLICY_TO_CONTINUE')}</p>
                                    </div> */}
                                    <button type="submit" className="btn btn-blue-white w-full lg:mt-2">{t('CONTACT_US.SEND_MESSAGE')}</button>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        </div>
    </div>
    );
};

export default GetInTouchComponent;

const SocialMediaLinkList: any[] = [
    {
        img: '/assets/images/svg/linkedin-black-icon.svg',
        title: 'COMMON.LINKEDIN',
        link: 'https://www.linkedin.com/company/innovii-digital-services/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BT9PjXTQ4Ra%2BGsb3yWq3Agw%3D%3D',
    },
    // {
    //     img: '/assets/images/svg/x-black-icon.svg',
    //     title: 'COMMON.X_FORMERLY_TWITTER',
    //     link: 'https://twitter.com',
    // },
    // {
    //     img: '/assets/images/svg/instagram-black-icon.svg',
    //     title: 'COMMON.INSTAGRAM',
    //     link: 'https://www.instagram.com',
    // },
    // {
    //     img: '/assets/images/svg/facebook-black-icon.svg',
    //     title: 'COMMON.FACEBOOK',
    //     link: 'https://www.facebook.com',
    // },
];

const countryCodeList = [
    { name: "SO", code: "+252" },
    { name: "KE", code: "+254" },
    { name: "IN", code: "+91" },
    { name: "US", code: "+1" },
    { name: "GB", code: "+44" },
];